import type { ExpandedSchedule } from "@/types/database/schedule";
import { useState } from "react";
import TimingExplainer from "./TimingExplainer";
interface Props {
	schedule: ExpandedSchedule;
}

const SchedulePreview = ({ schedule }: Props) => {
	const [expanded, setExpanded] = useState(false);

	// Sort timings by their chronological order (smaller intervals first)
	const sortedTimings = [...schedule.timings].sort((a, b) => {
		// Convert to comparable values based on time unit and interval
		const getTimeValue = (timing: typeof a) => {
			const timeUnitValues: Record<string, number> = {
				second: 1,
				minute: 60,
				hour: 60 * 60,
				day: 24 * 60 * 60,
				week: 7 * 24 * 60 * 60,
				month: 30 * 24 * 60 * 60,
			};
			return timing.interval * (timeUnitValues[timing.time_unit] || 0);
		};

		return getTimeValue(a) - getTimeValue(b);
	});

	const timings = expanded ? sortedTimings : sortedTimings.slice(0, 3);
	return (
		<div className="flex-1 min-w-0">
			<div className="flex justify-between items-center gap-2">
				<h3 className="w-full text-md text-slate-800 text-wrap">
					{schedule.schedule_name}
				</h3>
			</div>
			<div className="space-y-1 pl-2">
				{timings.map((timing) => (
					<div
						key={timing.timing_id}
						className="flex items-center gap-2 text-slate-600 text-sm"
					>
						<div className="bg-slate-400 rounded-full w-1 h-1" />
						{timing.is_autoname ? (
							<TimingExplainer timing={timing} />
						) : (
							<span>{timing.label}</span>
						)}
					</div>
				))}
				{schedule.timings.length > 3 && (
					<button
						onClick={() => setExpanded(!expanded)}
						type="button"
						className="flex items-center gap-2 text-indigo-600 text-sm"
					>
						<span className="italic">
							{expanded ? "Hide" : "Show"} {schedule.timings.length - 3} more
							timings
						</span>
					</button>
				)}
			</div>
		</div>
	);
};

export default SchedulePreview;
